import { Star } from "lucide-react";

const StarRating = ({ value = 0, onChange, size = 16 }) => (
  <div className="flex gap-0.5" data-testid="star-rating">
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        size={size}
        onClick={onChange ? () => onChange(i) : undefined}
        className={`${
          i <= Math.round(value) ? "fill-[#C59B27] text-[#C59B27]" : "text-[#D9C9A8]"
        } ${onChange ? "cursor-pointer transition-transform hover:scale-125" : ""}`}
      />
    ))}
  </div>
);

export default StarRating;
